import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "toggle-collapse",
  templateUrl: "./toggle-collapse.component.html",
  styleUrls: ["./toggle-collapse.component.css"]
})
export class ToggleCollapseComponent {

  isCollapsed = false;

  @Input() classesOnArrowIcon: string;

  @Output() collapsed = new EventEmitter<boolean>();

  handleClick() {
    this.isCollapsed = !this.isCollapsed;

    this.collapsed.emit(this.isCollapsed);
  }

}
